<script lang="js">
import { ArrowRightIcon, PlayCircleIcon } from 'vue-feather-icons';

export default {
  name: 'NoSupportSmallResolutionMessage',
  components: {
    ArrowRightIcon,
    PlayCircleIcon,
  },
};
</script>

<template>
  <div class="h-screen flex w-full bg-img">
    <div class="flex items-center justify-center w-full px-4">
      <div class="bg-white rounded-lg shadow-md p-8 text-center w-full" style="max-width: 30rem">
        <img
          alt="PuzzleTax mobile"
          class="mx-auto mb-6 max-w-full"
          style="max-width: 12rem"
          src="@assets/images/pages/graphic-2.png"
        >
        <h2 class="text-xl font-bold mb-4 text-gray-900">Korzystasz z telefonu lub tabletu?</h2>
        <p class="mb-4 leading-relaxed text-gray-700">
          Przejdź do mobilnej wersji PuzzleTax, dedykowanej do wystawiania faktur oraz przesyłania dokumentów:
        </p>
        <a
          href="https://preprod-puzzleapp.pages.dev/auth/login"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center justify-center text-primary mb-4 py-3"
        >
          <arrow-right-icon size="1x" class="mr-1" />
          Przejdź do aplikacji mobilnej PuzzleTax
        </a>
        <p class="mb-4 leading-relaxed text-gray-700">
          Aplikacja działa w technologii <strong>PWA</strong> – nie musisz nic pobierać ze sklepu.<br>
          Wystarczy przypiąć aplikację do ekranu startowego, aby korzystać z niej jak z natywnej aplikacji.
        </p>
        <a
          href="https://www.youtube.com/watch?v=rk1nxFBvUfU"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center justify-center text-primary py-3"
        >
          <play-circle-icon size="1x" class="mr-1" />
          Instrukcja wideo (YouTube)
        </a>
      </div>
    </div>
  </div>
</template>
